import React from "react";
import { useTranslation } from "react-i18next";
import FeedbackModal from "../feedback/FeedbackModal";

const Modal3dError = ({ show, onHide, errorType }) => {
  const { t } = useTranslation();
  const isIncomplete = errorType === "incomplete";

  return (
    <FeedbackModal
      show={show}
      onHide={onHide}
      severity={isIncomplete ? "error" : "warning"}
      title={
        isIncomplete
          ? t("message.error.3d_data_incomplete_title", "Incomplete Data")
          : t("Undefined layout")
      }
      message={
        isIncomplete
          ? t(
              "message.error.3d_data_incomplete",
              "Please fill in the required layout fields and ensure the bowler has a valid PAP configured.",
            )
          : t("message.warning.3d_layout_undefined")
      }
    />
  );
};

export default Modal3dError;
